import { Order, OrderProduct } from '@diamond/shared/types';
import { formatDateRange } from '@diamond/shared/utils';

import { ItemInfo } from '../promos/promos';
import { VoucherBannerData } from './voucher-banner-data';

type OrderAppliedVoucher = NonNullable<
  Order['vouchers']
>['applied_vouchers'][number] & {
  valid_from?: number | string;
  valid_until?: number | string;
};

export const extractOrderVoucherBannerData = (
  appliedVouchers: OrderAppliedVoucher[],
  orderProducts?: OrderProduct[]
): VoucherBannerData[] => {
  return appliedVouchers
    .filter((voucher) => voucher.reward_type === 'FREE_GOODS')
    .filter((voucher) => voucher.free_goods && voucher.free_goods.length > 0)
    .map((voucher) => {
      const allImages: string[] = [];

      voucher.free_goods.forEach((freeGood) => {
        if (orderProducts) {
          const orderProduct = orderProducts.find(
            (product) => product.item_code === freeGood.product_item_code
          );
          if (orderProduct?.product_images_medium?.[0]) {
            allImages.push(orderProduct.product_images_medium[0]);
          } else if (orderProduct?.product_images?.[0]) {
            allImages.push(orderProduct.product_images[0]);
          }
        }
      });

      const freeGood = voucher.free_goods[0];
      const freeQty = freeGood.quantity / 1000;

      let price = 0;
      if (orderProducts) {
        const orderProduct = orderProducts.find(
          (product) => product.item_code === freeGood.product_item_code
        );
        if (orderProduct?.price) {
          price = orderProduct.price;
        }
      }

      const savings =
        freeGood.saved_amount > 0 ? freeGood.saved_amount : undefined;

      const item: ItemInfo = {
        id: '',
        img: allImages[0] || '',
        price: price,
        qty: freeQty,
        uom: '',
      };

      const text = `Voucher ${voucher.voucher_code}: Gratis ${freeQty} ${freeGood.product_name}`;

      let dateRange = '';
      if (voucher.valid_from && voucher.valid_until) {
        const validFrom: string | Date =
          typeof voucher.valid_from === 'string'
            ? voucher.valid_from
            : new Date(voucher.valid_from);
        const validUntil: string | Date =
          typeof voucher.valid_until === 'string'
            ? voucher.valid_until
            : new Date(voucher.valid_until);
        dateRange = formatDateRange(validFrom, validUntil);
      }

      return {
        type: 'free-item',
        label: 'Gratis',
        text,
        dateRange,
        item,
        images: allImages.length > 0 ? allImages : undefined,
        savings,
        voucherCode: voucher.voucher_code,
        voucherId: voucher.voucher_id,
      };
    });
};
